import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

import AddToCart from '../common/AddToCart';
import AddToList from '../common/AddToList';

/* Dialogs */
import ViewPackageOverlayDialog from '../../dialogs/viewPackageOverlayDialog';
import ConfirmDeletePackage from '../../dialogs/confirmDeletePackage';

/* Actions */
import {
	getPackageList,
	savePackageList,
	getOrderDetailsList,
	saveOrderDetailsList,
	saveCreatedPackageDetails,
	cancelPackageOrder
} from '../../../redux/actions';

class Packages extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			packageListResponse: null,
			packageName: '',
			showViewPackageOverlayDialog: false,
			accountNumber: '',
			showConfirmDeletePackage: false,
			deletePackage:{}, 
			packageItem:null,
		}
	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		if(nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER !== this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER) {
			self.filterBySAAndUpdateState(JSON.parse(JSON.stringify(self.props.state.packages.packageList)), nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER);
		}
	}

	// life cycle event for get data
	componentDidMount() {
		let self = this,
			accountNumber = self.props.getSelectedAccountNumber();

		// check account number is exist or not
		if(accountNumber !== '') {
			self.setState({ // set account number in state
				accountNumber: accountNumber
			}, () => {
				// call api
				self.props.getPackageList('accountNumber='+self.state.accountNumber +'&requestType=packages', (response) => {
					if(!response.status) { // if data is not found
						self.setState({
							errorMessage: response.responseMessage
						});
					} else { // if data is found
						// set package order asc
				 		response.responseObject = _.orderBy(response.responseObject, ['orderHeader.ponumber'], ['asc']);
						//Save package list into store
						self.props.savePackageList(JSON.parse(JSON.stringify(response)));
						self.filterBySAAndUpdateState(response, self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER);
					}
				});
			})
		} else { // if not exist then display error message
			self.setState({
				errorMessage: 'No accountNumber found.'
			})
		}
	}

	filterBySAAndUpdateState(response, agreementNumber) {
		const self = this;
		response.responseObject = response.responseObject.filter(item => item.orderHeader.salesAgreement.agreementNumber === agreementNumber.toString());
		// set state
		self.setState({
			packageListResponse: response
		});
	}
	// close doilog box for model
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handlePackageDetails(packageName,orderNumber,event){
		event && event.preventDefault();
		const self = this;

		// call api
		self.props.getOrderDetailsList('orderNumber='+ orderNumber +'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status) { // if data is not found
				self.props.saveOrderDetailsList(null);
			} else {
				// set in to state
				this.setState({
					showViewPackageOverlayDialog: true,
					orderDetails: response.responseObject.items,
					packageName: packageName
				});
			}
		});
	}

	handleEditPackage(orderNumber, event) {
		event.preventDefault();
		const self = this;
		// call api
		self.props.getOrderDetailsList('orderNumber='+ orderNumber +'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status) { // if data is not found
				self.setState({
					errorMessage: 'Error occured while getting order details'
				});
			} else {
				self.props.getItemTypeByOrderDetails(response.responseObject, resp => {
					if(!resp.status) {
						self.setState({
							errorMessage: resp.responseMessage
						});
					} else {
						response.responseObject.items.forEach(item => {
							const itemTypeData = resp.orderDetails.items.find(itm => itm.item === item.item);
							if(itemTypeData) {
								item.itemType = itemTypeData.itemType;
							}
						});
						//Save order details list to store
						self.props.saveCreatedPackageDetails(response.responseObject);
						browserHistory.push('/editpackage');
					}
				});
			}
		});
	}

	handleDelete(item, event){
		event && event.preventDefault();
		const self = this;
		self.setState({
			packageItem: item,
			deletePackage : {
				"poNumber": item.orderHeader.ponumber,
				"orderNumber":item.orderHeader.orderNumber,
				"createdById": item.orderHeader.createdBy
			}
		})
		self.handleDialog("ConfirmDeletePackage", true);
	}

	cancelPackage(event){
		event && event.preventDefault();
		const self = this;
		this.props.cancelPackageOrder(self.state.deletePackage,'requestType=cancelOrder', (response) => { 
			let packageListResponse=self.state.packageListResponse && self.state.packageListResponse;
			 packageListResponse.responseObject=self.state.packageListResponse && self.state.packageListResponse.responseObject.filter(itm => itm!=this.state.packageItem )
			if(response.status && response.responseObject){
				self.setState({
					packageListResponse:packageListResponse
				});
				self.handleDialog("ConfirmDeletePackage", false);
			}    
		})
	}

    render() {
		const self = this;
		const {
            selectedPriceSource
        } = self.props.state.user;
        return (
            <div>
                <div className="push">
                    <h1 className="pageTitle">Packages</h1>
					<p>
						You are viewing a package for: &nbsp; <span className="bold">{selectedPriceSource && selectedPriceSource.AGREEMENT_NAME}</span>
					</p>
                    <p>You will need to add packages to your list to create a brochure.</p>
                </div>
				<p className="red bold">{self.state.errorMessage}</p>
                <table className="dataTableType2 createOrderTableB milktoast2" style={{width: '100%'}}>
                    <thead>
                        <tr>
                            <th colSpan="4">Package</th>
                        </tr>
                    </thead>
                    <tbody>
						{this.state.packageListResponse && this.state.packageListResponse.status && this.state.packageListResponse.responseObject.length === 0
							?<tr>
								<td colSpan={4}>
									No packages found for the selected account.
								</td>
							</tr>
							:null
						}
						{this.state.packageListResponse && this.state.packageListResponse.status && this.state.packageListResponse.responseObject.length > 0 && this.state.packageListResponse.responseObject.map((item, index) => {
							return <tr key={index} id={item.orderHeader.ponumber}>
								<td key={index}>
									<a href="" onClick={this.handlePackageDetails.bind(this, item.orderHeader.ponumber, item.orderHeader.orderNumber)}>{item.orderHeader.ponumber}</a>
								</td>
								<td >
									<a href=""  onClick={this.handleDelete.bind(this, item)}>{`X Delete`}</a>
								</td>
								<td className="editBrochure">
									<a className="editBrochureIcon" href="" onClick={this.handleEditPackage.bind(this, item.orderHeader.orderNumber)}><img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Package" title="Edit Package" />&nbsp; Edit Package</a>
								</td>
								<td className="packages">
									<AddToList
										fireGTMTag={this.props.fireGTMTag}
										getShippingAddressesDetails={this.props.getShippingAddressesDetails}
										getItemTypeByOrderDetails={this.props.getItemTypeByOrderDetails}
										item={item.sku}
										itemDescription={item.description}
										isPackage={true}
										packageName={item.orderHeader.ponumber}
										itemType={item.itemType}
										orderNumber={item.orderHeader.orderNumber}
										getZipCode={this.props.getZipCode}
										getLegacyCustCode={this.props.getLegacyCustCode}
										getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
									/>
								</td>
								<td>
									<AddToCart
										fireGTMTag={this.props.fireGTMTag}
										getPimDataForCartItem={this.props.getPimDataForCartItem}
										getItemTypeByOrderDetails={this.props.getItemTypeByOrderDetails}
										item={item.sku}
										brand={item.brand}
										category={item.category}
										itemDescription={item.description}
										isPackage={true}
										packageName={item.orderHeader.ponumber}
										itemType={item.itemType}
										orderNumber={item.orderHeader.orderNumber}
										getZipCode={this.props.getZipCode} getLegacyCustCode={this.props.getLegacyCustCode}
										getShippingAddressesDetails={this.props.getShippingAddressesDetails}
										makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
										getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
									/>
								</td>
							</tr>
						})}
                    </tbody>
                </table>
				{this.state.showViewPackageOverlayDialog?<ViewPackageOverlayDialog handleDialog={this.handleDialog.bind(this)} packageName={this.state.packageName} orderDetails={this.state.orderDetails} showDialog={true} />:null}
				{this.state.showConfirmDeletePackage?<ConfirmDeletePackage cancelPackage={this.cancelPackage.bind(this)} showDialog={true} handleDialog={this.handleDialog} />:null}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getPackageList: (queryStringParams, callback) => dispatch(getPackageList(queryStringParams, callback)),
	savePackageList: (packageList) => dispatch(savePackageList(packageList)),
	getOrderDetailsList: (queryStringParams, callback) => dispatch(getOrderDetailsList(queryStringParams, callback)),
	saveOrderDetailsList: (orderDetailsList) => dispatch(saveOrderDetailsList(orderDetailsList)),
	saveCreatedPackageDetails: (data) => dispatch(saveCreatedPackageDetails(data)),
	cancelPackageOrder:(payload, params, callback) => dispatch(cancelPackageOrder(payload, params, callback)),
});

Packages = connect(mapStateToProps, mapDispatchToProps)(Packages);
export default Packages;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Packages/index.js